export * from './DeleteMiniIcon'
